(function(window, captionsViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.CaptionsView = captionsViewFactory(window,
      window.$,
      namespace.localStorageWrapper,
      namespace.playerConfiguration,
      namespace.templates,
      namespace.localizationStrings,
      namespace.cssClasses,
      namespace.tabIndex,
      namespace.events,
      namespace.languageCodes);
})(this, function(window, $, localStorageWrapper, playerConfiguration, templates, localizationStrings, cssClasses, tabIndex, events, languageCodes) {
   'use strict';

   var _ccCacheKey = 'captionEnabled';

   /**
    * @memberof TSC
    * @class CaptionsView
    * @classdesc Captions View
    */

   var CaptionsView = function($container, captionsService) {
      var _markup = templates.captions_view_template({
         accessBtnClosedCaption: localizationStrings.strings.accessBtnClosedCaption,
         closedCaptionIndex: tabIndex.ClosedCaption
      });

      $container.find('.caption-wrapper').html(_markup);

      var _$controls = $container.find('#controls');
      var _$positionContainer = $container.find('.caption');
      var _$textContainer = $container.find('.caption > p');
      var _$closedCaptionButton = $container.find('.closed-caption-button');
      var _$closedCaptionGlyph = $container.find('.closed-caption-button-glyph');

      var _cachedCC = localStorageWrapper.getItem(_ccCacheKey);
      var _cachedCCValue = _cachedCC === 'true';
      var _fontSizeNormalized = captionsService.fontSize;
      var _canvasScale = 1.0;
      // if position is 'under' captions start as visible and the user cannot hide, else it is from config option
      var _visible = captionsService.position === 'under' ? true : playerConfiguration.getCaptionsEnabled();
      var _currentCaptionIndex = -1;

      var onClosedCaptionButtonClick = function() {
         setVisible(!_visible);
         localStorageWrapper.setItem(_ccCacheKey, _visible);
         handleDisplayCaptions();
      };

      var onCaptionLanguageChanged = function() {
         if (_currentCaptionIndex !== -1) {
            var currentCaption = captionsService.captionTrack.captionCollection.captions[_currentCaptionIndex];
            _$textContainer.html(currentCaption.markupText.replace('&para', '&amp;para'));
         }
      };

      var disableControl = function() {
         _$closedCaptionButton.attr('tabindex', tabIndex.Disabled);
      };

      var enableControl = function() {
         _$closedCaptionButton.attr('tabindex', tabIndex.ClosedCaption);
      };

      var setupEvents = function() {
         $container.on(events.Controls.Disable, disableControl);
         $container.on(events.Controls.Enable, enableControl);
         $container.on(events.Captions.LanguageChanged, onCaptionLanguageChanged);

         _$closedCaptionButton.on('click', onClosedCaptionButtonClick);
      };

      var destroy = function() {
         $container.off(events.Controls.Disable, disableControl);
         $container.off(events.Controls.Enable, enableControl);
         $container.off(events.Captions.LanguageChanged, onCaptionLanguageChanged);
         _$closedCaptionButton.off('click', onClosedCaptionButtonClick);
      };

      var updateStyles = function() {
         _$textContainer.css({
            'font-family': captionsService.fontEnclosedWithQuotes,
            color: captionsService.textColor.toString(),
            background: captionsService.backgroundColor.toString()
         });

         if (captionsService.position === 'under') {
            // toHexString masks the alpha component so we get a non-transparent full bg
            _$positionContainer.css('background', captionsService.backgroundColor.toHexString());
            _$positionContainer.addClass('caption_under_video');
            _$positionContainer.removeClass(cssClasses.hide);
         }
      };

      var setVisible = function(value) {
         if (value === true) {
            _$positionContainer.removeClass(cssClasses.hide);
            _$closedCaptionButton.attr('aria-expanded', true);
            _$closedCaptionButton.attr('aria-pressed', true);
         } else {
            _$positionContainer.addClass(cssClasses.hide);
            _$closedCaptionButton.attr('aria-expanded', false);
            _$closedCaptionButton.attr('aria-pressed', false);
         }
         _visible = value;
      };

      var setScale = function(value) {
         _canvasScale = value;

         var fontSize = Math.round(captionsService.fontSize * _canvasScale);
         fontSize = Math.min(Math.max(captionsService.fontSizeMin, fontSize), captionsService.fontSizeMax);
         _fontSizeNormalized = fontSize;

         if (captionsService.position === 'under') {
            _$positionContainer.css('height', captionsService.height * _canvasScale + 'px');
         }
         _$textContainer.css('font-size', _fontSizeNormalized);
         updateStyles();
      };

      var getVerticalAlignmentClass = function(verticalAlignment) {
         return verticalAlignment === 'top' ? 'captionVAlignTop' : 'captionVAlignBottom';
      };

      var getHorizontalAlignmentClass = function(horizontalAlignment) {
         switch (horizontalAlignment) {
            case 'left':
               return 'captionHAlignLeft';
            case 'right':
               return 'captionHAlignRight';
            default:
               return 'captionHAlignCenter';
         }
      };

      var handleDisplayCaptions = function() {
         if (captionsService.hasCaptions) {
            // deal with setting up captions 'under' video, causes us to restructure DOM elements a little =(
            if (captionsService.position === 'under') {
               playerConfiguration.setAutoHideControls(false);
               _$controls.addClass('caption_under_video');
            } else {
               var normalButtonClass = cssClasses.closedCaptionButtonGlyph;
               var activeButtonClass = cssClasses.closedCaptionButtonActiveGlyph;
               if (localizationStrings.getLanguage() !== languageCodes.ENGLISH) {
                  normalButtonClass = cssClasses.closedCaptionNonEnglishButtonGlyph;
                  activeButtonClass = cssClasses.closedCaptionNonEnglishButtonActiveGlyph;
               }
               _$closedCaptionButton.removeClass(cssClasses.hide);
               if (_visible === true) {
                  _$closedCaptionGlyph.removeClass(normalButtonClass).addClass(activeButtonClass);
                  _$closedCaptionButton.removeClass(cssClasses.tertiaryButton).addClass(cssClasses.tertiaryButtonActive);
               } else {
                  _$closedCaptionGlyph.removeClass(activeButtonClass).addClass(normalButtonClass);
                  _$closedCaptionButton.removeClass(cssClasses.tertiaryButtonActive).addClass(cssClasses.tertiaryButton);
               }
            }
            updateStyles();
            setScale(_canvasScale);
         } else {
            _$closedCaptionButton.addClass(cssClasses.hide);
         }
      };

      var updateCaption = function(currentTime, currentFile) {
         if (!captionsService.hasCaptions) {
            _$textContainer.html('');
            return;
         }

         var newCaptionIndex = -1;

         $.each(captionsService.captionTrack.captionCollection.captions, function(i, caption) {
            // this check is for playlist config, single media player use doesn't match here
            if (caption.file !== undefined && caption.file !== currentFile) {
               return;
            }

            if (caption.startTime <= currentTime && currentTime <= caption.endTime) {
               newCaptionIndex = i;
            }
         });

         if (newCaptionIndex === -1) {
            _$textContainer.html('');
            _currentCaptionIndex = -1;
            return;
         }

         if (newCaptionIndex !== _currentCaptionIndex) {
            _currentCaptionIndex = newCaptionIndex;
            var newCaption = captionsService.captionTrack.captionCollection.captions[newCaptionIndex];

            if (!(newCaption && newCaption.markupText)) {
               return;
            }

            _$positionContainer.removeClass('captionHAlignLeft captionHAlignCenter captionHAlignRight');
            _$positionContainer.addClass(getHorizontalAlignmentClass(newCaption.horizontalAlignment));

            _$positionContainer.removeClass('captionVAlignTop captionVAlignBottom');
            _$positionContainer.addClass(getVerticalAlignmentClass(newCaption.verticalAlignment));

            _$textContainer.html(newCaption.markupText.replace('&para', '&amp;para'));

            updateStyles();
            $container.trigger(events.Captions.Changed, newCaption);
         }
      };

      if (localizationStrings.getLanguage() !== languageCodes.ENGLISH) {
         _$closedCaptionGlyph.removeClass(cssClasses.closedCaptionButtonGlyph).addClass(cssClasses.closedCaptionNonEnglishButtonGlyph);
      }

      if (!playerConfiguration.getIgnoreStoredCaptionVisibleSetting() && !_visible && _cachedCCValue) {
         setVisible(true);
      } else {
         setVisible(_visible);
      }

      setupEvents();

      return Object.defineProperties({
         updateCaption: updateCaption,
         handleDisplayCaptions: handleDisplayCaptions,
         destroy: destroy
      }, {
         visible: {
            get: function() {
               return _visible;
            },
            set: setVisible
         },
         scale: {
            get: function() {
               return _canvasScale;
            },
            set: function(value) {
               setScale(value);
            }
         }
      });
   };

   return {
      /**
       *  Factory method that returns a new CaptionsView object.
       *  @function create
       *  @memberof TSC.CaptionsView
       *  @static
       *  @param {Object} $container - jQuery element that is the smartplayer top-level container that contains #controls, .closed-caption-button, .caption, .caption > p
       *  @param {TSC.CaptionService} CaptionService - a TSC.captionService created object
       *  @return new CaptionView instance
       */
      create: CaptionsView
   };
});
